import { useQuery } from 'react-query'

import { getBankPayment } from '@modules-deprecated/inbox/services/api'

import { QueryKeys } from '../../../enums/queryKeys'

export const useFetchBankPayment = (bankPaymentId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.BankPayment, bankPaymentId],
    () => getBankPayment(bankPaymentId as string),
    { enabled: !!bankPaymentId },
  )

  return { bankPayment: data?.bankPayment, isLoading }
}
